"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SOCIAL_MERGE_TYPE = exports.SOCIAL_CREATE_TYPE = exports.SOCIAL_AUTHENTICATE_TYPE = void 0;
const SOCIAL_AUTHENTICATE_TYPE = exports.SOCIAL_AUTHENTICATE_TYPE = 'social/authenticate/status_changed';
const SOCIAL_CREATE_TYPE = exports.SOCIAL_CREATE_TYPE = 'social/create/status_changed';
const SOCIAL_MERGE_TYPE = exports.SOCIAL_MERGE_TYPE = 'social/merge/status_changed';